// src/stores/NavigationStore.js
import { createSlice } from '@reduxjs/toolkit';

const navigationInitialState = {
  loginRedirectPath: null,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState: navigationInitialState,
  reducers: {
    setLoginRedirectPath(state, action) {
      state.loginRedirectPath = action.payload;
    },
    clearLoginRedirectPath(state) {
      state.loginRedirectPath = null;
    },
  },
});

export const { setLoginRedirectPath, clearLoginRedirectPath } = navigationSlice.actions;
export default navigationSlice.reducer;
